export default "__VITE_ASSET__Y8SMp9DC__"